import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks/data';

export default function Footer() {
  const [emailStatus, setEmailStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const [emailError, setEmailError] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value.trim();
    if (honeypot) {
      setEmailStatus('success');
      setTimeout(() => setEmailStatus('idle'), 3000);
      return;
    }
    setEmailStatus('sending');
    setEmailError('');
    try {
      const formData = new FormData(form);
      formData.delete('website_alt');
      const response = await fetch('https://readdy.ai/api/form/d9pn68mb4qjhggaeq1k0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      if (response.ok && parsed?.code === 'OK') {
        setEmailStatus('success');
        form.reset();
        setTimeout(() => setEmailStatus('idle'), 3000);
      } else {
        setEmailStatus('error');
        setEmailError(serverMsg || '订阅失败，请稍后重试');
      }
    } catch {
      setEmailStatus('error');
      setEmailError('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-heart-3-fill text-primary-400 text-xl"></i>
              </div>
              <span className="font-heading text-lg font-semibold tracking-wide">
                爱情岛论坛
              </span>
            </Link>
            <p className="text-sm text-secondary-300 leading-relaxed">
              爱情岛论坛独家提供最新、最全的优质内容资源，汇聚海量精选信息，为广大用户带来独一无二的专属体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" aria-label="微信" className="w-9 h-9 rounded-full bg-secondary-700 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" aria-label="微博" className="w-9 h-9 rounded-full bg-secondary-700 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" aria-label="邮箱" className="w-9 h-9 rounded-full bg-secondary-700 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">
              <a href="/category/qinggan" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">
              <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  用户口碑
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  联系方式
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  加入会员
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  内容合作
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">订阅我们</h4>
            <p className="text-sm text-secondary-300 mb-4">
              获取爱情岛论坛最新内容和独家福利
            </p>
            <form className="flex gap-2" data-readdy-form="" id="newsletter-form" onSubmit={handleNewsletterSubmit}>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱"
                className="flex-1 px-4 py-2.5 rounded-lg bg-secondary-800 border border-secondary-600 text-sm text-background-50 placeholder-secondary-400 focus:outline-none focus:border-primary-500 transition-colors"
                required
              />
              <button
                type="submit"
                disabled={emailStatus === 'sending'}
                className="px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 disabled:opacity-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                {emailStatus === 'sending' ? '...' : '订阅'}
              </button>
            </form>
            {emailStatus === 'success' && (
              <p className="text-xs text-green-400 mt-2">订阅成功！感谢您的关注。</p>
            )}
            {emailStatus === 'error' && (
              <p className="text-xs text-red-400 mt-2">{emailError}</p>
            )}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-secondary-400">
            &copy; 2026 爱情岛论坛 版权所有 | 爱情岛论坛独家提供
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors">服务条款</a>
            <a href="#" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors" rel="nofollow">友情链接</a>
          </div>
        </div>
      </div>
    </footer>
  );
}